import { createSelectorCreator, defaultMemoize } from 'reselect';
import _ from 'lodash';

export const createSelectorDeep = createSelectorCreator(defaultMemoize, _.isEqual);
